import { FieldValues, Path } from "react-hook-form";
import { useParentControlsTrigger } from "../hooks";

interface ParentTriggerProps<TFieldValues extends FieldValues> {
  name: Path<TFieldValues> | Path<TFieldValues>[];
  controls: Path<TFieldValues>[];
}

export default function ParentTrigger<TFieldValues extends FieldValues>(
  props: Readonly<ParentTriggerProps<TFieldValues>>,
) {
  const { name, controls } = props;
  useParentControlsTrigger(name, controls);
  return null;
}
